<ng-container *transloco="let t; read: 'user'">
<div class="p-5">
  <div class="flex flex-row">
    <div class="basis-full">
      <h1 class="pb-2 text-3xl">{{ t('dashboard.news.title') }}</h1>
    </div>
  </div>

  <drdp-container>
    @if (newsItems?.length == 0) {
      <div>
        {{ t('dashboard.news.empty') }}
      </div>
    }
    @for (news of newsItems; track news) {
      <div class="item py-3 px-2 flex justify-between">
        <div class="flex">
          @if (news.newsItemType.newsItemTypeName) {
            <drdp-pill class="order-2 sm:order-1 justify-self-end pr-0 sm:pr-3"
              [pillClass]="news.newsItemType.newsItemTypeName">
              <!-- Server-supplied news item type name. -->
              {{ news.newsItemType.newsItemTypeName }}
            </drdp-pill>
          }
          <p class="font-semibold self-start md:justify-end order-2 sm:order-2 w-24 text-left">
            {{ news.newsItemDate | localizedDate: 'MM/dd/yyyy'}}
          </p>
          <p class="mr-auto order-1 sm:order-3 w-9/12 sm:w-max cursor-pointer font-bold text-drdpblue-400 hover:underline"
            (click)='toggleModal(news)'>
            {{ news.newsItemTitle }}
          </p>
        </div>
        @if (canDelete) {
          <div (click)="deleteNewsItem(news)" class="cursor-pointer">
            <i class="uil uil-trash-alt text-xl text-drdpred-200"></i>
          </div>
        }
      </div>
    }
  </drdp-container>
</div>
</ng-container>